import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';


const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };

        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }

};

const PageLoad = (PageLoadBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_Pageload,
            JSON.stringify(PageLoadBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PageLoad", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const GridDataBind = (BinLocBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_GetData,
            JSON.stringify(BinLocBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "GridDataBind", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const DataBind = (BinLocBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_GetData,
            JSON.stringify(BinLocBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "DataBind", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const OnStatusChangeAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_inv_StatusOnchange,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "OnStatusChange", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const ApproveAllClick = (BO) => {

    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_ApproveAll,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    //$(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ApproveALL", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const ProcessReplenClick = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_ProcessReplen,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ProcessReplen", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const saveItem = (saveItemBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_SaveItem,
            JSON.stringify(saveItemBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SaveItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const getCurrentFavPage = async (getFavPageBO) => {
    
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "MobileInventory_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const insertFavPage = async (insertFavPageBO) => {
    
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "MobileInventory_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const deleteFavPage = async (deleteFavPageBO) => {
    
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "MobileInventory_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const ExportToExcelAction = async (ExportToExcelBO) => {
    
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.MobileInventoryManagement,
            SDIConstants.methodNames.Mob_Inv_ExportToExcel,
            JSON.stringify(ExportToExcelBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "excelClick", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};


export { PageLoad, GridDataBind, getCurrentFavPage, insertFavPage, deleteFavPage, saveItem, ProcessReplenClick, ApproveAllClick, OnStatusChangeAction, ExportToExcelAction, DataBind }